// extracted by mini-css-extract-plugin
module.exports = {"Container":"MobileMapDetails_Container__TYwzU","Tip":"MobileMapDetails_Tip__RliX7","Info":"MobileMapDetails_Info__hvjVq","Icon":"MobileMapDetails_Icon__u2cZ7"};